module.exports = __webpack_public_path__ + "static/media/android-badge-white@3x.2fed32d0.png";